import _ from 'lodash';
import { getInvalidGroupErrors, getInvalidSensitiveErrors } from
  '../../ReferralFormFields/MimicReferralGroupValidations/utils';

function buildErrorMap(selectedFields, groupKey, getErrors) {
  return selectedFields
    .filter((field) => getErrors(field[groupKey].value.id).length > 0)
    .map((field) => ({
      id: field[groupKey].value.id,
      errors: getErrors(field[groupKey].value.id),
    }))
    .reduce((acc, { id, errors }) => ({ ...acc, [id]: errors }), {});
}

export default function computeFieldErrors({
  selectedFields,
  groupKey,
  caseReferrals,
  ccGroupIds,
  referral,
  suggestedGroups,
  currentUserGroup,
}) {
  const sensitiveGroups = _.filter(suggestedGroups, (group) => group.sensitive);
  const sensitiveGroupIds = _.map(sensitiveGroups, (g) => g.id);
  const isCurrentUserGroupSensitive = _.get(currentUserGroup, 'sensitive');

  const errorsByField = buildErrorMap(selectedFields, groupKey, (groupId) => getInvalidGroupErrors({
    caseReferrals,
    ccGroupIds,
    fields: selectedFields,
    groupId,
    referral,
  }));

  const sensitiveErrorsByField = buildErrorMap(selectedFields, groupKey, (groupId) => getInvalidSensitiveErrors({
    caseReferrals,
    sensitiveGroupIds,
    isCurrentUserGroupSensitive,
    fields: selectedFields,
    groupId,
    referral,
  }));

  const sensitiveErrorKey = _.last(Object.keys(sensitiveErrorsByField));

  return { errorsByField, sensitiveErrorsByField, sensitiveErrorKey };
}
